import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// GET all work order comments
export const getWorkOrderComments = async () => {
  const response = await axiosInstance.get(`${API_URL}/work-order-comments`);
  return response.data;
};

// GET comments by work order id
export const getWorkOrderCommentsByWorkOrderId = async (workOrderId) => {
  const response = await axiosInstance.get(`${API_URL}/work-order-comments`, {
    params: { workOrderId },
  });
  return response.data;
};

// GET comments by many work order ids
export const getWorkOrderCommentsByWorkOrderIds = async (workOrderIds = []) => {
  if (!workOrderIds.length) {
    return [];
  }

  const response = await axiosInstance.get(
    `${API_URL}/work-order-comments/by-work-order-ids`,
    {
      params: { workOrderIds: workOrderIds.join(",") },
    },
  );
  return response.data;
};

// GET a single comment by id
export const getWorkOrderCommentById = async (id) => {
  const response = await axiosInstance.get(
    `${API_URL}/work-order-comments/${id}`,
  );
  return response.data;
};

// CREATE a new comment
export const createWorkOrderComment = async (data) => {
  const response = await axiosInstance.post(
    `${API_URL}/work-order-comments`,
    data,
  );
  return response.data;
};

// UPDATE a comment
export const updateWorkOrderComment = async (id, data) => {
  const response = await axiosInstance.put(
    `${API_URL}/work-order-comments/${id}`,
    data,
  );
  return response.data;
};

// DELETE a comment
export const deleteWorkOrderComment = async (id) => {
  const response = await axiosInstance.delete(
    `${API_URL}/work-order-comments/${id}`,
  );
  return response.data;
};
